module.exports = __webpack_public_path__ + "img/vip2.f810efd8.png";